export default "__VITE_ASSET__CUgqZqeF__"